document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => button.addEventListener('click', () => {
    const open = body.classList.toggle('menu-open');
    button.setAttribute('aria-expanded', String(open));
  }));
  document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', () => body.classList.remove('menu-open')));

  document.querySelectorAll('[data-tabs]').forEach((group) => {
    const tabs = group.querySelectorAll('[role="tab"]');
    const panels = group.querySelectorAll('[role="tabpanel"]');
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((item) => { item.setAttribute('aria-selected', 'false'); item.classList.remove('is-active'); });
      panels.forEach((panel) => panel.hidden = true);
      tab.setAttribute('aria-selected', 'true');
      tab.classList.add('is-active');
      const panel = group.querySelector(`#${tab.getAttribute('aria-controls')}`);
      if (panel) panel.hidden = false;
    }));
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ajax-cart]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    button?.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error((await response.json()).description || 'Unable to add item');
      const item = await response.json();
      if (window.RTPCart) {
        try { await window.RTPCart.refresh(true); }
        catch { window.location.assign(`${window.Shopify.routes.root}cart`); }
        return;
      }
      const toast = document.querySelector('#CartToast');
      toast.textContent = `${item.product_title} added to your cart.`;
      toast.classList.add('is-visible');
      setTimeout(() => toast.classList.remove('is-visible'), 3200);
      const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((r) => r.json());
      document.querySelectorAll('[data-cart-count]').forEach((node) => node.textContent = cart.item_count);
    } catch (error) { alert(error.message); }
    finally { button?.removeAttribute('aria-busy'); if (button) button.disabled = false; }
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!main || thumbs.length === 0) return;

    const showImage = (index) => {
      const nextIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[nextIndex];
      main.src = thumb.dataset.src;
      main.srcset = thumb.dataset.srcset;
      main.alt = thumb.dataset.alt || '';
      thumbs.forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
    gallery.querySelectorAll('[data-gallery-step]').forEach((button) => button.addEventListener('click', () => {
      const activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      showImage(activeIndex + Number(button.dataset.galleryStep));
    }));
  });

  document.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => {
    const input = button.parentElement?.querySelector('input[type="number"]');
    if (!input) return;
    const step = Number(input.step) || 1;
    const minimum = Number(input.min) || 1;
    input.value = String(Math.max(minimum, Number(input.value || minimum) + Number(button.dataset.quantityChange) * step));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }));

  document.querySelectorAll('.product-form').forEach((form) => {
    const quantity = form.querySelector('input[name="quantity"]');
    const variant = form.querySelector('select[name="id"]');
    const totalPrice = document.querySelector('[data-product-total-price]');
    const buttonPrice = form.querySelector('[data-product-button-price]');
    const priceContainer = document.querySelector('[data-product-price-container]');
    if (!quantity || !totalPrice || !priceContainer) return;

    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: priceContainer.dataset.currency || 'USD'
    });

    const updateTotal = () => {
      if (variant?.selectedOptions[0]?.dataset.price) totalPrice.dataset.unitPrice = variant.selectedOptions[0].dataset.price;
      const count = Math.max(Number(quantity.min) || 1, Number(quantity.value) || 1);
      let unitPrice = Number(totalPrice.dataset.unitPrice) || 0;
      form.querySelectorAll('[data-price-break]').forEach((priceBreak) => {
        if (count >= Number(priceBreak.dataset.minimumQuantity)) unitPrice = Number(priceBreak.dataset.breakPrice) || unitPrice;
      });
      const formattedTotal = formatter.format((unitPrice * count) / 100);
      totalPrice.textContent = formattedTotal;
      if (buttonPrice) buttonPrice.textContent = formattedTotal;
    };

    quantity.addEventListener('input', updateTotal);
    quantity.addEventListener('change', updateTotal);
    variant?.addEventListener('change', updateTotal);
    updateTotal();
  });

  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    if (!section.dataset.url || section.children.length > 0) return;
    try {
      const html = await fetch(section.dataset.url).then((response) => response.text());
      const replacement = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-recommendations]');
      if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML;
    } catch (error) { /* Recommendations are optional. */ }
  });

  const reveal = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); }), { threshold: .12 });
  document.querySelectorAll('[data-reveal]').forEach((node) => reveal.observe(node));
});
